import { useController, useFormContext } from 'react-hook-form';
import { FileDescription } from './FileDescription';
import { FilePicker } from './FilePicker';
import { ExtAttachmentType } from '../../../api/extForms';

export type FileItemProps = {
  name: string;
  fileDescription: ExtAttachmentType;
};

/**
 * FileItem component
 * @private
 *
 * @param name - name of the field
 * @param fileDescription - file description object
 */
export const FileItem: React.FC<FileItemProps> = ({
  name,
  fileDescription,
}) => {
  const {
    field: { value },
    fieldState: { error },
  } = useController({ name });
  const { setValue, clearErrors, setError } = useFormContext();

  return value ? (
    <FileDescription
      offerFile={fileDescription}
      file={value}
      error={error?.message}
      onRemove={() => {
        clearErrors(name);
        setValue(name, null);
      }}
    />
  ) : (
    <FilePicker
      error={error?.message}
      offerFile={fileDescription}
      maxSizeInKB={fileDescription.maxSize}
      acceptText={fileDescription.types.join(', ').toUpperCase()}
      setFile={file => {
        clearErrors(name);
        setValue(name, file);
      }}
      setError={errorToSet => {
        setError(name, errorToSet);
      }}
    />
  );
};
